import { useEffect } from 'react';
import type { ExportFilter } from '@casetrace/export';
import { useTopBarMenu } from '../../components/layout/top-bar-menu-context';
import type { FilterState } from './filter-panel';

function toExportFilter(filters: FilterState): ExportFilter {
  return {
    types: Array.from(filters.types),
    dateFrom: filters.dateFrom || undefined,
    dateTo: filters.dateTo || undefined,
  };
}

export function useSyncCaseMenuActions(input: {
  readonly caseId: string;
  readonly saksnummer: string;
  readonly filters: FilterState;
  readonly onOpenSources: () => void;
  readonly onOpenMembers: () => void;
}) {
  const { setCaseMenuActions } = useTopBarMenu();
  const { caseId, saksnummer, filters, onOpenSources, onOpenMembers } = input;

  useEffect(() => {
    setCaseMenuActions({
      caseId,
      saksnummer,
      filter: toExportFilter(filters),
      onOpenSources,
      onOpenMembers,
    });
    return () => setCaseMenuActions(null);
  }, [caseId, filters, onOpenMembers, onOpenSources, saksnummer, setCaseMenuActions]);
}
